import PropTypes from 'prop-types';

import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';

import classnames from 'classnames';
import Compare from 'components/svg/Compare';
import Copy from 'components/svg/Copy';
import Cross from 'components/svg/Cross';
import Favorite from 'components/svg/Favorite';
import Share from 'components/svg/Share';

const Button = styled.button`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	font-size: 15px;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	background-color: ${colors.primary.oceanLight};

	transition:
		background-color 0.2s cubic-bezier(0, 0, 0, 0),
		color 0.2s cubic-bezier(0, 0, 0, 0),
		transform 0.1s cubic-bezier(0, 0, 0, 0);

	svg {
		width: 16px;
		height: 16px;
		path {
			transition:
				stroke 0.2s cubic-bezier(0, 0, 0, 0),
				fill 0.2s cubic-bezier(0, 0, 0, 0);
		}
	}
	@media (min-width: ${sizes.media.tabletLandscape}px) {
		&:hover,
		&.selected {
			background-color: ${colors.secondary.deepCove};
			color: ${colors.primary.ice};

			svg {
				path {
					stroke: ${colors.primary.ice};
					fill: unset;
				}
			}
		}

		&.fill {
			&:hover,
			&.selected {
				background-color: ${colors.secondary.polar};
				color: ${colors.primary.ice};

				svg {
					path {
						fill: ${colors.primary.ocean};
						stroke: unset;
					}
				}
			}
		}
	}

	&:active {
		transform: scale(0.97);
	}
`;

const icons = {
	compare: Compare,
	cross: Cross,
	favorite: Favorite,
	share: Share,
	copy: Copy,
};

/**
 * RoundButtonWithIcon supertype.
 * Currently called only by other Round<Icon>Button components; but can be called without an needing icon-specific button component. Other icons can be adding and importing svgs in the related folder.
 *
 * @param {boolean} colorFill Determines whether icon stroke (false) or fill (true) is colored.
 * @param {func} onClick
 * @param {string} className
 * @param {string} icon - should match one of the imported svg components.
 */

const RoundButtonWithIcon = ({ onClick, icon, className, colorFill }) => {
	const classes = classnames({
		[className]: !!className,
		fill: colorFill,
	});
	const IconComponent = icons[icon];
	return (
		<Button className={classes} onClick={onClick}>
			{!!IconComponent && <IconComponent />}
		</Button>
	);
};

export const iconsEnum = Object.keys(icons);

RoundButtonWithIcon.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	icon: PropTypes.oneOf(iconsEnum).isRequired,
	colorFill: PropTypes.bool,
};

export default RoundButtonWithIcon;
